export default __webpack_public_path__ + "f3ba44e6b598eb29415a7f62437cc164.svg";